import { ElementType } from 'react';
import Select, { FormatOptionLabelMeta, SingleValue } from 'react-select';
import { OptionProps } from '../FormField/FormField';
import { Country, getCountryCallingCode } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

type Option = {
  value: string;
  label: string;
  divider: boolean;
};

export type FormPhoneFieldDropdownProps = {
  value?: string;
  onChange: (value?: string) => void;
  options: Option[];
  iconComponent: ElementType;
  menuPlacement?: 'auto' | 'top' | 'bottom';
};

export function FormPhoneFieldDropdown(props: FormPhoneFieldDropdownProps) {
  const { value, onChange, options, iconComponent, menuPlacement } = props;
  const Icon = iconComponent;

  const getValue = () => {
    const foundValue = options?.find(option => option.value === value) ?? null;

    return foundValue;
  };

  const onSelectChange = (option: SingleValue<OptionProps>) => {
    onChange(option?.value);
  };

  const formatOptionLabel = (
    country: Option,
    meta: FormatOptionLabelMeta<Option>,
  ) => {
    if (!country.value) {
      return <div className={'divider'} />;
    }

    if (meta.context === 'menu') {
      return (
        <div>
          <Icon aria-hidden country={country.value} label={country.label} />
          <span className={'country-name'}>{country.label}</span>
          <span className={'dial-code'}>{` +${getCountryCallingCode(
            country.value as Country,
          )}`}</span>
        </div>
      );
    }

    return <Icon aria-hidden country={country.value} label={country.label} />;
  };

  return (
    <div className="flag-dropdown">
      <Select
        classNamePrefix={'custom__select'}
        isClearable={false}
        value={getValue()}
        onChange={onSelectChange}
        options={options}
        isOptionDisabled={option => !option.value}
        formatOptionLabel={formatOptionLabel}
        isSearchable={false}
        autoFocus={true}
        menuPlacement={menuPlacement || 'auto'}
      />
    </div>
  );
}

export default FormPhoneFieldDropdown;
